import React from 'react';
import { SButton, SIcon, type SButtonProps } from '@chargebee/sting-react';

export const CloseButton: React.FC<SButtonProps> = (props) => (
  <SButton aria-label="Close" variant="neutral-ghost" {...props}>
    <SIcon name="x" />
  </SButton>
);
